// based imports router
import { h } from 'vue';
import { createRouter, createWebHistory, RouterView } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

// import middleware
import Middleware from './middleware.js';

// import translation
import Tr from "@/i18n/translation";

// import components
import Wrapper from '@/theme/layouts/Wrapper.vue';
import Login from '@/views/auth/Login.vue';

// Recupero la gerarchia di ruoli
const roleHierarchy = Middleware.getRoleHierarchy();

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_URL),
  routes: [
    {
      path: "/:locale?",
      component: Wrapper,
      beforeEnter: Tr.routeMiddleware,
      children: [
        // Login
        {
          path: 'login',
          name: 'login',
          component: Login,
          meta: { requiresAuth: false, isLoginPage: true }
        },

        // Dashboard e altre route protette
        {
          path: '',
          name: 'dashboard',
          component: () => import('@/views/RemoteLogs.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'logs',
          name: 'logs',
          component: () => import('@/views/Logs.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'remote-logs',
          name: 'remoteLogs',
          component: () => import('@/views/RemoteLogs.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'imei-search',
          name: 'imei-search',
          component: () => import('@/views/ImeiSearch.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'imei-stats',
          name: 'imei-stats',
          component: () => import('@/views/imei/ImeiStats.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'parser',
          name: 'parser',
          component: () => import('@/views/MessageParser.vue'),
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'notFound',
      component: () => import('@/views/404.vue'),
      meta: { requiresAuth: false }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0, behavior: 'smooth' };
  }
});

// Middleware per l'autenticazione con gestione errori
router.beforeEach(async (to, from, next) => {
    try {
        const authStore = useAuthStore();
        const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
        const isLoginPage = to.matched.some(record => record.meta.isLoginPage);
        const hasToken = !!authStore.token;
        const isAuthenticated = authStore.isAuthenticated;

        // Se stiamo andando alla pagina di login
        if (isLoginPage) {
            // Se siamo già autenticati e abbiamo un token valido, redirect alla home
            if (isAuthenticated && hasToken) {
                next('/');
                return;
            }
            // Altrimenti permetti l'accesso alla pagina di login
            next();
            return;
        }

        // Se la rotta richiede autenticazione
        if (requiresAuth) {
            // Se non siamo autenticati o non abbiamo un token valido
            if (!isAuthenticated || !hasToken) {
                next('/login');
                return;
            }
        }

        // In tutti gli altri casi, procedi normalmente
        next();
    } catch (error) {
        console.error('Errore nel middleware di autenticazione:', error);
        next('/login');
    }
});

export default router;
